// extracted by mini-css-extract-plugin
export default {"numberYears":"NumberYears_numberYears__DQcfp","numberYears__container":"NumberYears_numberYears__container__LCyfG"};